import { fetchToken } from "../../common/FetchCookie"
import { BASE_URL, CANDIDATE, CANDIDATE_MOST_ACTIVE_RECENT_JOBS } from "../../common/URLs"

export const fetchCandidateMostActiveRecentJobs = async () => {
    const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_MOST_ACTIVE_RECENT_JOBS}`

    try {
        const token = await fetchToken()

        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",

            }
        })

        const data = await response.json()
        return data
    } catch (error) {
        console.log("error", error);

    }
}